<script setup lang="ts">
import { computed } from 'vue';
import VLazyImage from 'v-lazy-image';
import type { Picture } from '~/types';

interface Props {
  image?: Picture;
}

const props = defineProps<Props>();
const altText = computed(() => props.image?.alt?.replace(/\..*/, ''));
</script>

<template>
  <VLazyImage v-if="image" :src="image.src" :srcset="image.srcset" :alt="altText" />
</template>
